import { observable, computed, action, decorate } from 'mobx';
import { INSURANCE_GETCLIENTINFO } from 'api';

class ProfileModule {
    constructor(props, appStore) {
        this.appStore = appStore;
    }

    user = {};

    get userNameNavbar() {
        if (this.user.name && this.user.surname) {
            return `${this.user.name} ${this.user.surname.charAt(0)}.`;
        }

        return '';
    }

    setUser(value) {
        this.user = value
    }

    getClientInfo() {
        return INSURANCE_GETCLIENTINFO()
            .then((data) => {
                const { result } = data;

                this.user = result;
            }).catch(() => {
                if (Object.keys(this.user).length !== 0) {
                    if (window.location.pathname.indexOf('/support') !== -1 || this.user.isSupport) {
                        window.location.replace('/support');
                    } else {
                        window.location.replace('/login');
                    }
                    this.user = {};
                }
            });
    }
}

decorate(ProfileModule, {
    user: observable,
    userNameNavbar: computed,
    getClientInfo: action.bound,
    setUser: action.bound,
});

export default ProfileModule;
